export const IGNORED_DUMMY_ACCOUNTS_IDS = [
    "6gjniTQqPhba3IF0JFRSOpLVlVq1",
    "DrC0T3jVpgOrlBnRY23ituTIy7G3",
    "GvCD3z6i0BgQb2xjGRZSZdOJ0362",
    "MjVugeZ5ytZFqBqJtDeJ9SdGOjs1",
    "MrKANKYP4ITAmzDhmVfGBvGfH5j1",
    "Qe3klg0ma3Ti4jjpXJAHOAU3Ge13",
    "fcHtGrCwxPhxMbBRNOuv10YlLJT2",
    "gRoQIHe5LAXOrBidXDvX04wxS7N2",
    "hGgoOKseplc58EUcX3ZFslo8wng1",
    "oHJMSk41SLUa6WQEcV5G8cy719V2",
    "spSJqkM8tLQT9dqlkaCsVsApcSh1",
    "RJR1psasXUPY7jC0eHwv7rgjgG62",
    "OviQ0IWhj8XyMG9kqGAlRIliGcs1",
    "lxzlp3O3Wvhvn0O71cSkhUmP7Zu2",
    "utPiHC1hRKcCxCpIpEa4P62EA633",
    "NvVsUqPkitNp6cycCC9SS6kH3yi1",
    "k8JtB448yEP9fWoe4zhyvNvsd283",
    "ve0gmREPSEWyKhilQFcnKvzPyGk2",
    "Z0L0BtwyUac8TzFXlwA7dZbGYSG3"
];
